import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";

const LegalWrap = ({ children }) => (
  <SiteLayout>
    <section className="brp-paper">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24">{children}</div>
    </section>
  </SiteLayout>
);

const H = ({ children }) => <h2 className="mt-10 text-xl sm:text-2xl font-display font-semibold tracking-tight text-[hsl(var(--brp-ink-on-paper))]">{children}</h2>;
const P = ({ children }) => <p className="mt-3 text-[15px] leading-relaxed text-[hsl(var(--brp-ink-muted-on-paper))]">{children}</p>;

export default function TermsPage() {
  const year = new Date().getFullYear();
  return (
    <LegalWrap>
      <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--brp-orange))]">Legal</div>
      <h1 data-testid="legal-page-title" className="mt-3 text-3xl sm:text-4xl font-display font-semibold tracking-tight text-[hsl(var(--brp-ink-on-paper))]">Terms &amp; Conditions</h1>
      <p className="mt-2 text-sm text-[hsl(var(--brp-ink-muted-on-paper))]">Effective January 1, {year}</p>

      <P>Welcome to Brilliant Regular People Tech (“BRP Tech,” “we,” “us,” or “our”). These Terms of Use govern your access to and use of brptech.com and any related services, features, or content we provide.</P>

      <H>Acceptance of Terms</H>
      <P>By accessing or using our website, you agree to be bound by these Terms of Use and our Privacy Policy. If you do not agree, please discontinue use of the website.</P>

      <H>Use of the Website</H>
      <P>You may use the website for lawful purposes only. You agree not to use the website in any manner that could damage, disable, overburden, or impair our services, or interfere with any other party’s use and enjoyment of the website.</P>

      <H>Intellectual Property</H>
      <P>All content on the website — including text, graphics, logos, images, software, and interfaces — is the property of BRP Tech or its licensors and is protected by intellectual property laws. You may not copy, reproduce, modify, distribute, or create derivative works without our prior written consent.</P>

      <H>User Responsibilities</H>
      <P>You are responsible for maintaining the confidentiality of any credentials associated with your account and for all activities that occur under your account.</P>

      <H>Acceptable Use</H>
      <P>You agree not to (i) violate any applicable law or regulation, (ii) upload or transmit any unlawful, harmful, or objectionable material, (iii) attempt to gain unauthorized access to any portion of the website or any systems or networks connected to the website.</P>

      <H>User Accounts</H>
      <P>If you create an account, you agree to provide accurate, complete, and current information and to promptly update it as needed. We reserve the right to suspend or terminate accounts that violate these Terms.</P>

      <H>Purchases and Payments</H>
      <P>Certain services and products may be offered for purchase through the website. All pricing, availability, and payment terms will be clearly disclosed at the time of purchase. Payments are processed by trusted third-party providers.</P>

      <H>Subscription Services</H>
      <P>If you subscribe to any recurring service, you authorize us to charge the applicable fees on a recurring basis until you cancel in accordance with the cancellation instructions provided.</P>

      <H>Digital Products</H>
      <P>Digital products purchased through the website are licensed, not sold. Except as expressly stated at the time of purchase, all sales of digital products are final.</P>

      <H>Third-Party Links</H>
      <P>The website may contain links to third-party websites. We are not responsible for the content, policies, or practices of any third-party website.</P>

      <H>Disclaimer of Warranties</H>
      <P>The website and all content are provided “as is” and “as available” without warranties of any kind, either express or implied.</P>

      <H>Limitation of Liability</H>
      <P>To the maximum extent permitted by law, BRP Tech shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the website or services.</P>

      <H>Indemnification</H>
      <P>You agree to indemnify and hold BRP Tech, its affiliates, officers, employees, and agents harmless from any claims, damages, obligations, losses, liabilities, costs, or expenses arising from your use of the website or violation of these Terms.</P>

      <H>Governing Law</H>
      <P>These Terms are governed by and construed in accordance with the laws of the State of Tennessee, without regard to its conflict of laws principles.</P>

      <H>Termination</H>
      <P>We may suspend or terminate your access to the website at any time, with or without notice, for conduct that we believe violates these Terms or is otherwise harmful to other users or our business.</P>

      <H>Changes to the Terms</H>
      <P>We may revise these Terms from time to time. The most current version will always be posted on this page. Continued use of the website after any change constitutes acceptance of the revised Terms.</P>

      <H>Contact Information</H>
      <P>Questions about these Terms may be directed to legal@brptech.com.</P>
    </LegalWrap>
  );
}
